import { qs } from "@fluorescent/dom";

import { animateFilterSidebar, shouldAnimate } from "@/lib/animation";
import { emit } from "@/glow/events";

const selectors = {
  sidebar: "[data-filter-sidebar]",
  sidebarForm: "[data-filter-form]",
  sidebarToggle: "[data-sidebar-toggle]",
};

const FilterSidebar = node => {
  if (!node) return;

  const sidebarEl = qs(selectors.sidebar, node);
  if (!sidebarEl) return;

  const sidebarToggleEl = qs(selectors.sidebarToggle, node);

  let filterSidebarAnimation = null;

  if (shouldAnimate(node)) {
    filterSidebarAnimation = animateFilterSidebar(sidebarEl);
  }

  if (sidebarEl.dataset.defaultOpen === "true") {
    showSidebar();
  }

  function toggleSidebar() {
    const ariaHidden = sidebarEl.getAttribute("aria-hidden") === "true";

    if (ariaHidden) {
      showSidebar();
    } else {
      hideSidebar();
    }
  }

  function showSidebar() {
    if (sidebarToggleEl) {
      sidebarToggleEl.setAttribute("aria-expanded", true);
    }

    sidebarEl.setAttribute("aria-hidden", false);

    window.requestAnimationFrame(() => {
      if (shouldAnimate(node)) {
        filterSidebarAnimation.open();
      }
    });
  }

  function hideSidebar() {
    if (sidebarToggleEl) {
      sidebarToggleEl.setAttribute("aria-expanded", false);
    }

    sidebarEl.setAttribute("aria-hidden", true);

    window.requestAnimationFrame(() => {
      if (shouldAnimate(node)) {
        filterSidebarAnimation.close();
      }
    });
  }

  function renderFilters(doc) {
    emit("filters:render-filters", { doc });
  }

  function unload() {}

  return {
    toggleSidebar,
    renderFilters,
    unload,
  };
};

export default FilterSidebar;
